<script>
	import Card from '$lib/components/card.svelte';
	import { SplideSlide } from '@splidejs/svelte-splide/components';
	import Swiper from './swiper.svelte';
	import AudioCard from '$lib/components/audioCard.svelte';
	import { browser } from '$app/environment';
	import play from '$lib/assets/play.webp';
	import { blur, fade } from 'svelte/transition';
	import Modal from '$lib/components/modal.svelte';
	import Gallery from '$lib/components/gallery.svelte';

	export let items;
	const options = ['All'];
	items.map((item) => {
		options.push(item.name);
	});
	let selected = options[0];
	$: sortedFiles = selected == 'All' ? items : items.filter((item) => item.name == selected);
</script>

<div class="w-full flex flex-col justify-center items-center">
	<div
		class="w-full sticky top-[105px] lg:top-[115px] xl:top-[125px] bg-[#F6F6F6] z-10 text-lg max-lg:text-base max-sm:text-[15px]"
	>
		<div
			class="w-[min(1860px,95%)] h-16 max-lg:h-14 max-sm:py-2 flex justify-between items-center mx-auto sm:gap-5 z-10 relative gap-0"
		>
			<div class="flex gap-2 sm:gap-5">
				{#each options as option}
					<button
						class="group relative overflow-hidden pb-2"
						on:click={() => {
							selected = option;
							if (browser) {
								document
									.getElementById('start')
									.scrollIntoView({ behavior: 'smooth', block: 'start' });
							}
						}}
						>{option}
						<div
							class="absolute -bottom-0 h-1 w-full bg-[#f8991d] {selected == option
								? 'left-0'
								: 'left-[-100%]'} ease-in-out duration-300 group-hover:left-0"
						></div></button
					>
				{/each}
			</div>
			<slot name="year-list"></slot>
		</div>
	</div>
	<div
		class="w-[min(1860px,95%)] py-10 max-md:py-5 flex flex-wrap justify-center items-center gap-5 text-[rgba(0,0,0,0.7)]"
	>
		{#if selected == 'All'}
			{#each sortedFiles as item}
				{#if item.collections.length > 0}
					<div class="w-full flex flex-col">
						<h2>{item.name}</h2>
						<div class="w-full flex flex-wrap justify-center items-center gap-5">
							{#if item.collections}
								<Swiper>
									{#each item.collections as collection, i}
										{#if item.name == 'Audios'}
											<SplideSlide>
												<AudioCard
													title={collection.title}
													thumbnailUrl={collection.field_gallery_item.thumbnail.uri.url}
													audioUrl={collection.field_gallery_item.field_media_audio_file.uri.url}
												/>
											</SplideSlide>
										{:else if item.name == 'Videos'}
											<SplideSlide>
												<Modal
													desc_class="overflow-hidden px-2"
													body_class="max-w-[min(992px,92%)] bg-black"
												>
													<svelte:fragment slot="trigger"
														><div
															class="max-md:w-[300px] max-md:h-[200px] h-[275px] w-[400px] gap-2 hover:shadow-[2px_2px_17px_#8686864d] my-3 duration-300 ease-in-out border-[#EDEDED] border-solid border-[1px] overflow-hidden"
															transition:blur={{ amount: 10, delay: 100 }}
														>
															<div class="w-full h-full bg-black flex justify-center items-center">
																<div
																	class="w-[60px] h-[60px] rounded-full gradient flex justify-center items-center"
																>
																	<img src={play} class="w-[40px]" alt="icon" />
																</div>
															</div>
														</div>
													</svelte:fragment>
													<svelte:fragment slot="body">
														<Gallery data={item?.collections} active={i} />
													</svelte:fragment>
												</Modal>
											</SplideSlide>
										{:else if item.name == 'Books'}
											{#each collection?.collections as collection}
												<SplideSlide>
													<Card
														title={collection.title}
														thumbnailUrl={collection.field_gallery_item.field_media_document.uri
															.url}
														pdfUrl={collection.field_gallery_item.field_media_document.uri.url}
														id={collection.id}
													/>
												</SplideSlide>
											{/each}
										{/if}
									{/each}
								</Swiper>
							{/if}
						</div>
					</div>
				{/if}
			{/each}
		{:else}
			<div
				class="w-full {sortedFiles[0].name != 'Books'
					? 'grid'
					: 'flex flex-col'} grid-cols-[repeat(auto-fit,minmax(320px,1fr))] place-items-center gap-5 relative py-10"
			>
				{#each sortedFiles[0].collections as item, i}
					{#if sortedFiles[0].name == 'Audios'}
						<AudioCard
							title={item.title}
							thumbnailUrl={item.field_gallery_item.thumbnail.uri.url}
							audioUrl={item.field_gallery_item.field_media_audio_file.uri.url}
						/>
					{:else if sortedFiles[0].name == 'Videos'}
						<Modal desc_class="overflow-hidden px-2" body_class="max-w-[min(992px,92%)] bg-black">
							<svelte:fragment slot="trigger"
								><div
									class="max-md:w-[300px] max-md:h-[200px] h-[275px] w-[400px] gap-2 hover:shadow-[2px_2px_17px_#8686864d] my-3 duration-300 ease-in-out border-[#EDEDED] border-solid border-[1px] overflow-hidden"
									transition:blur={{ amount: 10, delay: 100 }}
								>
									<div class="w-full h-full bg-black flex justify-center items-center">
										<div
											class="w-[60px] h-[60px] rounded-full gradient flex justify-center items-center"
										>
											<img src={play} class="w-[40px]" alt="icon" />
										</div>
									</div>
								</div>
							</svelte:fragment>
							<svelte:fragment slot="body">
								<Gallery data={sortedFiles[0].collections} active={i} />
							</svelte:fragment>
						</Modal>
					{:else if sortedFiles[0].name == 'Books'}
						<div class="w-full flex flex-col gap-5">
							<h2 class="text-xl lg:text-2xl text-center font-bold text-black">{item.name}</h2>
							<div
								class="grid grid-cols-1 min-[680px]:grid-cols-2 lg:grid-cols-3 min-[1370px]:grid-cols-4 min-[1690px]:grid-cols-5 gap-5 place-items-center"
								in:fade={{ duration: 1000 }}
							>
								{#each item.collections as collection}
									<Card
										title={collection.title}
										thumbnailUrl={collection.field_gallery_item.field_media_document.uri.url}
										pdfUrl={collection.field_gallery_item.field_media_document.uri.url}
										id={collection.id}
									/>
								{/each}
							</div>
						</div>
					{/if}
				{/each}
			</div>
		{/if}
	</div>
</div>
